/**
 * 정적 리소스 루트 (public/ 하위)
 * - /assets : 로그인·회원가입·로비 공용
 * - /assets_seotda | /assets_holdem : 인게임·칩·얼굴·TTS 등 (assetsGen 규칙: `assetsGen/ASSETS_GEN_RULES.md`)
 */

import { FE_DEFAULT_PUBLIC_GAME_TYPE } from "@/lib/game/feBundleDefaults";

export const ASSETS_COMMON = "/assets";
export const ASSETS_SEOTDA = "/assets_seotda";
export const ASSETS_HOLDEM = "/assets_holdem";

/** 로비에서 섯다/홀덤 전환 시 인게임 에셋 루트 동기화용 */
export const LOBBY_GAME_STORAGE_KEY = "seotda_lobby_game";

/** 로비·로그인 등 공용 이미지 (/assets/images/...) */
export const COMMON_IMAGES = `${ASSETS_COMMON}/images` as const;

export function getGameAssetsRoot(): string {
  if (typeof window !== "undefined") {
    const path = String(window.location?.pathname || "");
    if (path.startsWith("/games_holdem")) return ASSETS_HOLDEM;
    if (path.startsWith("/games_seotda")) return ASSETS_SEOTDA;
    try {
      const v = window.sessionStorage.getItem(LOBBY_GAME_STORAGE_KEY);
      if (v === "HOLDEM") return ASSETS_HOLDEM;
      if (v === "SEOTDA") return ASSETS_SEOTDA;
    } catch {
      /* ignore */
    }
  }
  return FE_DEFAULT_PUBLIC_GAME_TYPE === "HOLDEM" ? ASSETS_HOLDEM : ASSETS_SEOTDA;
}

/** 로비 등에서 섯다/홀덤 번들을 명시할 때 */
export type GameBundleId = "SEOTDA" | "HOLDEM";

export function gameAssetsRootFor(game: GameBundleId): string {
  return game === "HOLDEM" ? ASSETS_HOLDEM : ASSETS_SEOTDA;
}

export function gameImageUrlFor(game: GameBundleId, relativePath: string): string {
  const trimmed = relativePath.replace(/^\/+/, "");
  return `${gameAssetsRootFor(game)}/images/${trimmed}`;
}

/** 인게임 이미지 경로 (칩·카드·배경·로비 모드 아이콘 등) */
export function gameImageUrl(relativePath: string): string {
  const trimmed = relativePath.replace(/^\/+/, "");
  return `${getGameAssetsRoot()}/images/${trimmed}`;
}
